import React, { useEffect, useState } from 'react';
import { fetchLibraryRecords, LibraryRecord } from '../services/dashboardApi';

const LibraryRecordsTable: React.FC = () => {
  const [data, setData] = useState<LibraryRecord[]>([]);

  useEffect(() => {
    const loadData = async () => {
      const result = await fetchLibraryRecords();
      setData(result);
    };
    loadData();
  }, []);

  return (
    <div className="card card-flush h-100 shadow-sm">
      <div className="card-header pt-7 pb-3">
        <h3 className="card-title">
          <span className="card-label fw-bold text-gray-800">Library Records</span>
        </h3>
      </div>
      <div className="card-body pt-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table  table-row-dashed gy-4 align-middle">
            <thead>
              <tr className="fw-bold text-gray-800 bg-light">
                <th className="ps-4 rounded-start">Library</th>
                <th className="text-center">Records<br/><span className="text-muted fw-normal fs-8">Current Yr/Total</span></th>
                <th className="text-center rounded-end">Documents<br/><span className="text-muted fw-normal fs-8">Current Yr/Total</span></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td className="ps-4">
                    <span className="text-gray-800 fw-semibold">{item.libraryName}</span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">
                      {item.rec}
                    </span>
                  </td>
                  <td className="text-center">
                    <span className="text-gray-700">
                      {item.doc}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LibraryRecordsTable;
